import { render, staticRenderFns } from "./canceltable.vue?vue&type=template&id=5f0a8376&scoped=true&"
import script from "./canceltable.vue?vue&type=script&lang=js&"
export * from "./canceltable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0a8376",
  null
  
)

export default component.exports